/** How often the list — and an open run that is still going — refetches while
 *  the page is visible. */
export const AUTO_REFRESH_MS = 15_000;

export const BACKGROUND_JOB_STATUSES = [
  'pending',
  'processing',
  'completed',
  'failed',
] as const;
